import { useDispatch, useSelector } from 'react-redux'
import { appActions } from 'apps/formsCreationKit/store/reducers/entities/app'
const { updateName } = appActions

import { formNameSelector } from 'apps/formsCreationKit/store/selectors/entities'
import { plgDemoSelector } from 'apps/studio/store/selectors/studioSettings'
import { EditableLabel } from 'apps/studio/components/shared/inputs/EditableLabel'
import { FormDropdown } from 'apps/studio/components/header/FormDropdown'
import { folderIdSelector } from 'apps/formsCreationKit/store/selectors/settings'

import { EditIcon } from '@gocanvas/gcds/icons'
import { useTextWidth } from 'hooks/useTextWidth'
import { useOnOutsideClick } from 'hooks/useOnOutsideClick'
const placeholder = 'Type Form Name'

export const HeaderOptionsLeft = () => {
  const dispatch = useDispatch()
  const formName = useSelector(formNameSelector)
  const folder_id = useSelector(folderIdSelector)
  const plgDemo = useSelector(plgDemoSelector)

  const { width: formNameWidth, parentRef } = useTextWidth({
    text: formName,
    minText: placeholder, // used when text is empty
  })

  useOnOutsideClick(parentRef, () => {
    if (parentRef.current.contains(document.activeElement)) {
      document.activeElement.blur()
    }
  })

  return (
    <div className="header-section header-left">
      <FormDropdown plgDemo={plgDemo} />
      <span className="divider">/</span>
      <div
        className="form-name"
        style={{ '--label-length': `${formNameWidth}` }}
        ref={parentRef}
      >
        <EditableLabel
          className="form-name--input"
          label={formName}
          limit={100}
          placeholder={placeholder}
          update={value => dispatch(updateName(value))}
        />
        <EditIcon className="form-name--edit-icon" />
      </div>
    </div>
  )
}
